import { Component, Input } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
  selector: 'spv2-grid-boolean-filter',
  templateUrl: './grid-boolean-filter.component.html',
  styleUrls: ['./grid-boolean-filter.component.scss']
})
export class GridBooleanFilterComponent extends GridFilterBase<string> {
  @Input() smallView = false;
}
